import GuidUtils from '@/shared/utils/guid'

export default class LocalTraining {
  constructor({
    id,
    name
  } = {}) {
    this.id = id || GuidUtils.emptyGuid,
    this.name = name
  }
}